import { render, staticRenderFns } from "./SeferTorahPublicTable.vue?vue&type=template&id=1288ea28&scoped=true&"
import script from "./SeferTorahPublicTable.vue?vue&type=script&lang=js&"
export * from "./SeferTorahPublicTable.vue?vue&type=script&lang=js&"
import style0 from "./SeferTorahPublicTable.vue?vue&type=style&index=0&id=1288ea28&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1288ea28",
  null
  
)

export default component.exports